import { OnlineSalesUnauthenticated } from 'gw-edge-client';
import { selector } from 'recoil';
import { jobInfoAtom } from '../atoms/jobInfoAtom';
import { getOnsaCurrentProductSelector } from './getOnsaCurrentProductSelector';
import { isLoggedOnSelector } from './isLoggedOnSelector';

export const claimsHistorySelector = selector<boolean>({
    key: 'claimsHistorySelector',
    get: async ({ get }) => {
        const { jobNumber, sessionId } = get(jobInfoAtom);
        const currentProduct = get(getOnsaCurrentProductSelector);
        const isLoggedOn = get(isLoggedOnSelector);

        if (currentProduct === undefined) {
            return false;
        }

        const { lobCode, fixedId } = currentProduct;

        return await OnlineSalesUnauthenticated.shouldSendClaimsHistory(
            jobNumber,
            lobCode,
            fixedId,
            sessionId,
            !isLoggedOn
        );
    }
});
